import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Work from "./views/Work.vue";
import SingleWork from "./views/Single-work.vue";
import News from "./views/News.vue";
import SingleNews from "./views/Single-news.vue";
import AboutUs from "./views/About.vue";
import Contact from "./views/Contact.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { path: "*", component: Home },
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/works",
      name: "works",
      component: Work,
    },
    {
      path: "/works/:lang/:slug",
      name: "work",
      component: SingleWork,
    },
    {
      path: "/news",
      name: "news",
      component: News,
    },
    {
      path: "/news/:lang/:slug",
      name: "SingleNews",
      component: SingleNews,
    },
    {
      path: "/about",
      name: "AboutUs",
      component: AboutUs,
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact,
    },
  ],
});
